module.exports = __webpack_public_path__ + "img/oneBlue.80e07726.jpg";